import { SelectOption } from "./filter-controls";

/**
 * The choices of a «Įmonė» drop-down: «Visos», then the companies of these rows by name. The
 * company the address asks for is always among them: when no row of it is shown (a link
 * or a reload), the box would otherwise say «Visos» while the filter is on. Its name falls
 * back to its id. A company without a name is left out.
 */
export function companyOptions(
  rows: { companyId: string; companyName: string }[],
  selectedId: string,
  allLabel: string
): SelectOption[] {
  const namesById = new Map<string, string>();
  rows.forEach(({ companyId, companyName }) => {
    if (companyName) namesById.set(companyId, companyName);
  });
  if (selectedId && !namesById.has(selectedId)) namesById.set(selectedId, selectedId);

  const companies = Array.from(namesById, ([value, label]) => ({ value, label }));
  companies.sort((a, b) => a.label.localeCompare(b.label));
  return [{ value: "", label: allLabel }, ...companies];
}
